import makeStyles from '@mui/styles/makeStyles';

export const callcenterStyle = makeStyles(theme => ({
	main: {
		backgroundColor: theme.palette.background.default,
		minHeight: "100vh",
		width: "100%"
	},
	menuButton: {
		marginRight: theme.spacing(1),
		marginLeft: theme.spacing(2)
	},
	logo: {
		width: 48,
		height: 48,
		margin: theme.spacing(1),
		cursor: "pointer"
	},
	fakeDiv: {
		[theme.breakpoints.down('sm')]: {
			flexGrow: 1
		},
	},
	icon: {
		color: theme.palette.mode !== "light" ? "#FFF" : "#000"
	},
	header: {
		display: "flex",
		alignItems: "center",
		/*position: "sticky",
		 top: 0,
		 zIndex: 1299,
		 backgroundColor: theme.palette.mode === "light" ? theme.palette.primary.main : theme.palette.primary.light,
		 color: theme.palette.mode === "light" ? "#000" : "#FFF",
		 borderRadius: "0 0 24px 24px",
		 marginBottom: theme.spacing(2),*/
	},
	title: {
		flexGrow: 1,
		paddingLeft: theme.spacing(1),
		color: theme.palette.mode === "light" ? "#000" : "#FFF",
		//color: theme.palette.text.primary,
		[theme.breakpoints.down('md')]: {
			fontSize: 20
		},
		[theme.breakpoints.down('sm')]: {
			display: "none",
			width: "auto"
		},
	},
	profile: {
		width: 48,
		height: 48
	},
	article: {
		//
	},
	firstRow: {
		display: "grid",
		gridTemplateColumns: "1fr 600px",
		width: "100%",
		[theme.breakpoints.down('lg')]: {
			display: "flex",
			flexDirection: "column",
		},
	},
	section: {
		padding: theme.spacing(1),
	},
	form: {
		padding: theme.spacing(2)
	},
	paper: {
		borderRadius: 24,
		height: "100%",
	},
	fab: {
		margin: theme.spacing(2),
		position: "fixed",
		bottom: 0,
		right: 0,
		zIndex: 10,
	},
	secondaryFab: {
		margin: theme.spacing(2),
		position: "fixed",
		bottom: 0,
		right: 228,
		zIndex: 10,
	},
	extendedIconFab: {
		marginRight: theme.spacing(1),
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		flexShrink: 0,
	},
	input: {
		textTransform: "uppercase",
	},
	capitalizeInput: {
		textTransform: "capitalize",
	},
	MuiAccordionRoot: {
		"&:before": {
			backgroundColor: "rgba(0,0,0,0)"
		}
	},
}))
